export enum MediaType {
  BOOK = "BOOK",
  ARTICLE = "ARTICLE",
}

export enum MarkType {
  EXCERPT = "excerpt",
  NOTE = "note",
}

export function parseMarkType(markType: string): MarkType {
  return markType.toLowerCase() as MarkType;
}

export enum MarksOrderByStrategy {
  RECENTLY_ADDED = "recentlyAdded",
  PAGE_NUMBER = "pageNumber",
}
